import request from '@/api/request'

export default {
  async getDepartments () {
    return (await request.get(`module/action/marketplace/zoom/product/departments`)).data
  },
  async getSubDepartments (department) {
    return (await request.get(`module/action/marketplace/zoom/product/sub_departments/${department}`)).data
  }
}



// WEBPACK FOOTER //
// ./src/api/marketplace/zoom/index.js